








































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { IAuditResult } from 'simple-apostille-v2';
import { format } from 'date-fns';
import { Address } from 'symbol-sdk';
import AMetadata from '@/models/AMetadata';
import OwnerEditModal from '../edit/OwnerEditModal.vue';

@Component({
  components: {
    OwnerEditModal,
  },
})
export default class ConfirmedResultComponent extends Vue {
  @Prop()
  public auditResult?: IAuditResult;

  @Prop()
  public txHash?: string;

  @Prop()
  public filename?: string;

  @Prop()
  public cosignatories?: Address[];

  @Prop()
  public metadatas?: AMetadata[];

  private ownerDialog = false;

  private metadataDialog = false;

  private timestamp() {
    if (this.auditResult && this.auditResult.timestamp) {
      return format(this.auditResult.timestamp, 'yyyy-MM-dd HH:mm:ss');
    }
    return '';
  }

  private signerAccount() {
    if (this.auditResult && this.auditResult.signer) {
      return this.auditResult.signer.plain();
    }
    return '';
  }

  private apostilleAccount() {
    if (this.auditResult && this.auditResult.apostilleAccount) {
      return this.auditResult.apostilleAccount.plain();
    }
    return '';
  }

  private closeOwnerDialog() {
    this.ownerDialog = false;
  }

  private closeMetadataDialog() {
    this.metadataDialog = false;
  }

  private signerLink() {
    return `http://explorer.testnet.symboldev.network/accounts/${this.signerAccount()}`;
  }

  private apostilleAccountLink() {
    return `http://explorer.testnet.symboldev.network/accounts/${this.apostilleAccount()}`;
  }

  private transactionLink() {
    return `http://explorer.testnet.symboldev.network/transactions/${this.txHash}`;
  }

  private cosinatoryLink(a: Address) {
    return `http://explorer.testnet.symboldev.network/transactions/${a.plain()}`;
  }
}

